import React, { useEffect } from 'react';

// eslint-disable-next-line no-restricted-imports -- Initial import for FullScreenLoader
import { FullScreenLoader } from '@opendoor/bricks/core';
import { useSearchParams } from '@remix-run/react';

import { useWelcomeToHubContext } from 'growth/components/welcomeToHub/WelcomeToHubContext';
import { WelcomeToHubLoadingPage } from 'growth/components/welcomeToHub/WelcomeToHubLoadingPage';

import { LoadingPageWithText } from './LoadingPageWithText';
import { useTOSContext } from './TOSProvider';

/** Loading page */
export const LoadingPage: React.FC<{
  /** @deprecated - not used anymore */
  from?: string;
  /** @deprecated - not used anymore */
  reason?: string;
}> = () => {
  const { wthVariant } = useWelcomeToHubContext();
  const [queryParams] = useSearchParams();
  const { forceHideTOSModal } = useTOSContext();

  // DO NOT REMOVE: Do not show the TOS modal on this page
  useEffect(() => {
    // set this as false on the initial render - so it doesn't show it on this page
    forceHideTOSModal(true);
    return () => {
      // allow the TOS component to be shown when we unmount
      forceHideTOSModal(false);
    };
  }, [forceHideTOSModal]);

  if (wthVariant) {
    return <WelcomeToHubLoadingPage variant={wthVariant} />;
  }

  if (queryParams.get('refresh_offer') === 'true') {
    return <LoadingPageWithText text="Updating your offer" />;
  }

  return <FullScreenLoader />;
};
